import type {
  CronMonitorAttentionItem,
  CronMonitorChartSegment,
  CronMonitorRunningItem,
  CronMonitorSummaryStat,
} from '../types'

export const CRON_MONITOR_LAST_UPDATED = 'Today, 10:28 AM'

export const CRON_MONITOR_SCHEDULER_BANNER = {
  status: 'Scheduler healthy',
  nextRunIn: '1m 43s',
}

export const CRON_MONITOR_SUMMARY_STATS: CronMonitorSummaryStat[] = [
  {
    id: 'successful',
    label: 'Successful',
    value: '156',
    sublabel: 'Completed runs',
    tone: 'success',
  },
  {
    id: 'failed',
    label: 'Failed',
    value: '3',
    sublabel: 'Failed queue jobs',
    tone: 'danger',
  },
  {
    id: 'running',
    label: 'Running',
    value: '8',
    sublabel: 'Reserved by a worker',
    tone: 'warning',
  },
  {
    id: 'missed',
    label: 'Missed',
    value: '2',
    sublabel: 'Past expected run time',
    tone: 'purple',
  },
  {
    id: 'stuck',
    label: 'Stuck',
    value: '0',
    sublabel: 'Reserved > 30 min',
    tone: 'danger',
  },
  {
    id: 'waiting',
    label: 'Waiting',
    value: '0',
    sublabel: 'Not yet reserved',
    tone: 'warning',
  },
]

export const CRON_MONITOR_CHART_SEGMENTS: CronMonitorChartSegment[] = [
  { label: 'Failed', value: 6, percent: 14.3, color: '#ef4444' },
  { label: 'Stuck', value: 1, percent: 2.4, color: '#3b82f6' },
  { label: 'Missed', value: 0, percent: 0, color: '#a855f7' },
  { label: 'Waiting', value: 35, percent: 83.3, color: '#eab308' },
]

export const CRON_MONITOR_ATTENTION_ITEMS: CronMonitorAttentionItem[] = [
  {
    id: 'failure-1',
    type: 'failures',
    jobName: 'PaymentCaptureJob',
    occurredAt: 'Today, 09:15 AM',
    duration: '32s',
    error: 'Payment capture failed for batch #8934',
    severity: 'high',
  },
  {
    id: 'failure-2',
    type: 'failures',
    jobName: 'PolicyReminderJob',
    occurredAt: 'Today, 06:42 AM',
    duration: '18s',
    error: 'SMTP connection timeout',
    severity: 'high',
  },
  {
    id: 'failure-3',
    type: 'failures',
    jobName: 'ResidentDefaultReLetJob',
    occurredAt: 'Yesterday, 11:30 PM',
    duration: '21s',
    error: 'Database deadlock found',
    severity: 'medium',
  },
  {
    id: 'missed-1',
    type: 'missed',
    jobName: 'GenrateTradelinesSummaryJob',
    occurredAt: 'Yesterday, 08:30 AM',
    duration: '—',
    error: 'Last success: 26 hours ago',
    severity: 'medium',
  },
  {
    id: 'missed-2',
    type: 'missed',
    jobName: 'PendingPolicyReportJob',
    occurredAt: 'Yesterday, 06:00 AM',
    duration: '—',
    error: 'Last success: 28 hours ago',
    severity: 'medium',
  },
  {
    id: 'stuck-1',
    type: 'stuck',
    jobName: 'ResidentDefaultExpiredClaimJob',
    occurredAt: 'Today, 09:43 AM',
    duration: '45m',
    error: 'Reserved 45m ago · Attempts: 2',
    severity: 'high',
  },
  {
    id: 'stuck-2',
    type: 'stuck',
    jobName: 'ApiLogsArchiveJob',
    occurredAt: 'Today, 09:50 AM',
    duration: '38m',
    error: 'Reserved 38m ago · Attempts: 1',
    severity: 'medium',
  },
]

export const CRON_MONITOR_RUNNING_JOBS: CronMonitorRunningItem[] = [
  {
    jobName: 'NinjaBankPendingJob',
    started: 'Since 10:16 AM',
    duration: '12m 34s',
  },
  {
    jobName: 'PaymentCaptureJob',
    started: 'Since 10:20 AM',
    duration: '8m 12s',
  },
  {
    jobName: 'SystemEmail',
    started: 'Since 10:25 AM',
    duration: '3m 45s',
  },
]

export const CRON_MONITOR_SCHEDULER_DETAILS = {
  lastRun: 'Today, 10:28 AM',
  lastRunLabel: 'On time',
  nextRun: 'Today, 10:34 AM',
  nextRunCountdown: 'In 1m 43s',
  source: 'ECS EventBridge',
  server: 'ECS Scheduler Task',
}
